var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-left"
  }, [_c('div', {
    staticClass: "container-left-title"
  }, [_c('a', {
    staticClass: "container-left-title-menu1",
    on: {
      "click": function click($event) {
        return _vm.viewTo('processApplication');
      }
    }
  }, [_c('img', {
    staticClass: "container-left-title-menu1-img",
    attrs: {
      "src": require("../../../assets/img/form-apply.png"),
      "alt": ""
    }
  }), _c('div', [_vm._v("表单申请")])]), _c('a', {
    staticClass: "container-left-title-menu1",
    on: {
      "click": function click($event) {
        return _vm.viewTo('myApplication');
      }
    }
  }, [_c('img', {
    staticClass: "container-left-title-menu1-img",
    attrs: {
      "src": require("../../../assets/img/my-apply.png"),
      "alt": ""
    }
  }), _c('div', [_vm._v("我的申请")])]), _c('a', {
    staticClass: "container-left-title-menu1",
    on: {
      "click": function click($event) {
        return _vm.viewTo('register');
      }
    }
  }, [_c('img', {
    staticClass: "container-left-title-menu1-img1",
    attrs: {
      "src": require("../../../assets/img/service-apply.png"),
      "alt": ""
    }
  }), _c('div', [_vm._v("报修申请")])]), _c('a', {
    staticClass: "container-left-title-menu1",
    on: {
      "click": function click($event) {
        return _vm.viewTo('register');
      }
    }
  }, [_c('img', {
    staticClass: "container-left-title-menu1-img2",
    attrs: {
      "src": require("../../../assets/img/my-service.png"),
      "alt": ""
    }
  }), _c('div', [_vm._v("我的报修")])])]), _c('div', {
    staticClass: "container-left-main-wapper"
  }, [_c('homeMain', {
    ref: "refresh",
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "mainList": _vm.mainList,
      "showLoading": _vm.showLoading
    }
  }), _c('homeMain', {
    ref: "refresh1",
    attrs: {
      "mainList1": _vm.mainList1,
      "showLoading1": _vm.showLoading1
    }
  })], 1)]), _c('div', {
    staticClass: "container-right"
  }, [_c('div', {
    staticClass: "container-right-title"
  }, [_c('div', {
    staticClass: "container-right-title-weather"
  }, [_c('div', {
    staticClass: "container-right-title-weather-left"
  }, [_c('div', {
    staticClass: "container-right-title-weather-left-txt"
  }, [_vm._v(" " + _vm._s(_vm.GdTq.temperature || _vm.defaultNumber) + "℃ ")]), _c('div', {
    staticClass: "container-right-title-weather-left-txt1"
  }, [_c('div', [_vm._v(_vm._s(_vm.GdTq.weather))]), _c('div', [_vm._v(_vm._s(_vm.GdTq.city))])]), _c('img', {
    staticClass: "container-right-title-weather-right-img",
    attrs: {
      "src": _vm.imgUrl || _vm.defaultImgUrl,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "container-right-title-riqi"
  }, [_c('div', {
    staticClass: "container-right-title-riqi1"
  }, [_vm._v(_vm._s(_vm.nowTime))]), _c('div', {
    staticClass: "container-right-title-riqi2"
  }, [_vm._v(_vm._s(_vm.nowDate) + " " + _vm._s(_vm.nowWeek))])])])]), _c('div', {
    staticClass: "container-right-box-wapper"
  }, [_c('homeSamll', {
    ref: "smallRef",
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "allList": _vm.allList,
      "showLoading2": _vm.showLoading2
    }
  }), _c('homeSamll', {
    ref: "repairs",
    attrs: {
      "allList1": _vm.allList1,
      "showLoading3": _vm.showLoading3
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };